export default "__VITE_ASSET__SJCcP34X__"